import React from "react";
import EvaToolDetail from "modules/eva/containers/EvaToolDetail";

const EvaToolDetailPage: React.FC = () => {
  return <EvaToolDetail />;
};

export default EvaToolDetailPage;
